import { Link } from 'react-router-dom';
import { work } from '@/mocks/home';
import SmartLink from '@/components/feature/SmartLink';

export default function Work() {
  const [lead, ...rest] = work;
  return (
    <section id="work" className="bg-background-50 sec">
      <div className="wrap">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-20" data-reveal>
          <h2 className="h-sec text-foreground-950">Selected work.</h2>
          <span className="label-xs text-foreground-600">Illustrative engagements</span>
        </div>
        <article data-reveal>
          <Link to={`/work/${lead.slug}`} className="block group cursor-pointer">
          <div data-clip className="w-full aspect-[4/3] md:aspect-[16/7] overflow-hidden">
            <img src={lead.img} alt={`${lead.title} — illustrative engagement`} title={lead.title} className="w-full h-full object-cover object-center" />
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-3 mt-5">
            <span className="label-xs text-foreground-600 lg:col-span-4 pt-2">{lead.sector}</span>
            <h3 className="h-card text-foreground-950 lg:col-span-4">{lead.title}</h3>
            <p className="text-[15px] leading-[1.6] text-foreground-700 lg:col-span-4 max-w-[400px]">{lead.text}</p>
          </div>
          </Link>
        </article>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-14 mt-16 md:mt-24">
          {rest.map((w) => (
            <article key={w.title} data-reveal>
              <Link to={`/work/${w.slug}`} className="flex flex-col group cursor-pointer">
              <div data-clip className="w-full aspect-[3/2] overflow-hidden">
                <img src={w.img} alt={`${w.title} — illustrative engagement`} title={w.title} className="w-full h-full object-cover object-center" />
              </div>
              <span className="label-xs text-foreground-600 mt-5">{w.sector}</span>
              <h3 className="h-card text-foreground-950 mt-2.5">{w.title}</h3>
              <p className="mt-3 text-[15px] leading-[1.6] text-foreground-700 max-w-[440px]">{w.text}</p>
              </Link>
            </article>
          ))}
        </div>
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-6 mt-16 border-t border-foreground-950/15 pt-6">
          <p className="label-xs text-foreground-600 max-w-xl leading-relaxed">Illustrative composites of the work we do &mdash; not specific client results.</p>
          <div className="flex flex-wrap items-center gap-8">
          <Link to="/work" className="label-xs text-foreground-950 link-line pb-1 cursor-pointer whitespace-nowrap">View all work</Link>
          <SmartLink href="#contact" className="group inline-flex items-center gap-4 label-xs text-foreground-950 cursor-pointer whitespace-nowrap">Discuss a challenge<span className="circle-arrow inv-dark"><i className="ri-arrow-right-line" /></span></SmartLink>
          </div>
        </div>
      </div>
    </section>
  );
}